var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{attrs:{"loading":_vm.loading,"alternative":""}},[_c('Slides'),_c('About'),_c('Protocol'),_c('BlueProtocol'),_c('CincinnatiScale'),_c('Questions'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }